import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CandidaturaService {
  private readonly path = 'profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllCandidatura`,
      this.getParams(params),
      true
    );
  }
  listByProfissionalId(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllCandidaturaByProfissionalId/${id}`,
      this.getParams(),
      true
    );
  }
  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getCandidaturaById/${id}`,
      this.getParams(),
      true
    );
  }
  add(data: any): Observable<any> {
    return this.apiService.post(`${this.path}/AddCandidatura`, data, true);
  }
  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateCandidatura`,
      data,
      this.getParams(),
      true
    );
  }
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteCandidaturaById/${id}`);
  }

  GetStory(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/HistoricoCandidatura/${id}`,
      this.getParams(),
      true
    );
  }

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
